import { Button } from "@mui/material";

export const PrimaryButton = (props) => {
  const {
    click,
    title,
    fullWidth,
    padding,
    borderRadius,
    textTransform,
    disabled,
    color,
    margin,
  } = props;
  return (
    <Button
      fullWidth={fullWidth}
      variant="contained"
      type="submit"
      disabled={disabled}
      sx={{
        color: color ? color : "color.black",
        padding: padding ? padding : "0.8rem",
        margin: margin ? margin : "",
        bgcolor: "color.magentaLight2",
        borderRadius: borderRadius ? borderRadius : 1,
        fontWeight: "bold",
        "&:hover": {
          bgcolor: "color.magentaLight2",
        },
        textTransform: textTransform,
      }}
      onClick={click}
    >
      {title ? title : t("next")}
    </Button>
  );
};

export const SecondaryButton = (props) => {
  const {
    type,
    click,
    title,
    width,
    textAlign,
    padding,
    border,
    borderRadius,
    fontSize,
    fontWeight,
    marginLeft,
    hoverBgColor,
    textTransform,
    disabled,
    variant,
  } = props;
  return (
    <Button
      type={type}
      variant="outlined"
      sx={{
        color: variant === "light" ? "color.blackV1" : "#ffffff",
        padding: padding ? padding : "0.209rem 1.2rem",
        fontWeight: fontWeight ? fontWeight : "regular",
        fontSize: fontSize ? fontSize : "0.775rem",
        border: border ? border : "1px solid black",
        borderRadius: borderRadius ? borderRadius : "17px",
        marginLeft: marginLeft ? marginLeft : "0",
        bgcolor: variant === "light" ? "#ffffff" : "color.blackV1",
        width: width ? width : "auto",
        textAlign: textAlign ? textAlign : "center",
        "&:hover": {
          bgcolor: hoverBgColor ? hoverBgColor : "color.transparent",
          border: border ? border : "1px solid #c298bb",
          backgroundColor: variant === "light" ? "#FFA37224" : "#F07837",
        },
        textTransform: textTransform ? textTransform : "initial",
      }}
      onClick={click}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};

export const CommonButton = (props) => {
  const {
    type,
    click,
    title,
    width,
    textAlign,
    padding,
    border,
    borderRadius,
    fontSize,
    fontWeight,
    margin,
    bgColor,
    hoverBgColor,
    textTransform,
    disabled,
    float,
    color,
    maxHeight,
  } = props;
  return (
    <Button
      type={type}
      variant="outlined"
      sx={{
        color: color ? color : "#ffffff",
        float: float ? float : "right",
        padding: padding ? padding : "0.209rem 1.2rem",
        fontWeight: fontWeight ? fontWeight : "regular",
        fontSize: fontSize ? fontSize : "0.775rem",
        border: border ? border : "1px solid black",
        borderRadius: borderRadius ? borderRadius : "17px",
        margin: margin ? margin : "0",
        bgcolor: bgColor ? bgColor : "color.primary",
        width: width ? width : "auto",
        textAlign: textAlign ? textAlign : "center",
        "&:hover": {
          bgcolor: hoverBgColor ? hoverBgColor : "color.primary",
          border: border ? border : "1px solid #000",
        },
        textTransform: textTransform ? textTransform : "initial",
        maxHeight: maxHeight ? maxHeight : "auto",
      }}
      onClick={click}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};
